import { Modal } from 'antd';

interface PropType {
  isModalOpen: boolean,
  callBack: () => void,
  content: string
}

const App = (props: PropType) => {
  const { isModalOpen, callBack, content } = props

  const handleOk = () => {
    callBack();
  };

  const handleCancel = () => {
    callBack();
  };

  return (
    <>
      <Modal title="温馨提示" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
        <p>{content}</p>
      </Modal>
    </>
  );
};

export default App;